import { render, staticRenderFns } from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=template&id=5dd1afad&"
import script from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=script&lang=js&"
export * from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=script&lang=js&"
import style0 from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports